export default "__VITE_ASSET__ce6dd408__"